/**
 * Vordefinierte Animation und Animationseffekte
 * @class service_v3sAnimationService
 * @memberOf v3sWbtPlayerApp:animation
 */
angular.module('v3sWbtPlayerApp').factory('v3sAnimationService', ["$rootScope", "v3sMediaService", "v3sPopupService", "v3sLinkService", "v3sNavigationService", "v3sExerciseService", "v3sPrintService", "v3sSearchService", "v3sCalculatorService", "$timeout", function ($rootScope, v3sMediaService, v3sPopupService, v3sLinkService, v3sNavigationService, v3sExerciseService, v3sPrintService, v3sSearchService, v3sCalculatorService, $timeout) {

    var audio = null;

    var propertyBlocks = {};

    /**
     * Erstellt Animation-Tween
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} action - Aktion
     * @param {bool} execute - wenn true, wird kein Tween erzeugt, sondern die Aktion direkt ausgeführt
     * @return Animation-Tween
     */
    function createTween(action, execute) {
        var tween = null,
            element = null;

        if (!!action.object) {
            var elementIds = action.object.split(";");
            element = document.getElementById(elementIds[0]);
        }

        var animation = { init: {}, from: {}, to: { overwrite: "none" }, end: {}, clearProps: [] };
        var duration = action.duration;
        if (duration == 0) {
            animation.to.immediateRender = false;
        }

        if (!!action.ease) {
            if (action.ease == "bounce") {
                if (action.command == "hide") {
                    animation.to.ease = Bounce.easeIn;
                } else {
                    animation.to.ease = Bounce.easeOut;
                }
            } else {
                animation.to.ease = EaseLookup.find(action.ease);
            }
        }

        if (action.command == "moveTo" && !!element) {
            createMoveAnimation(element, action, animation);

        } else if (action.command == "moveAlongPath" && !!element) {
            createMoveAlongPathAnimation(element, action, animation);

        } else if (action.command == "scale" && !!element) {
            createScaleToAnimation(element, action, animation);

        } else if (action.command == "rotate" && !!element) {
            createRotateToAnimation(element, action, animation);

        } else if (action.command == "play" && !!element) {
            duration = 5;
            createPlayback(element, action, animation);

        } else if (action.command == "stop") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist
            stopPlayback(element, action, animation);

        } else if ((action.command == "show" || action.command == "hide") && !!element) {
            createVisibilityAnimation(element, action, animation);

            if (action.effect == "clip") {
                createClipAnimation(element, action, animation);
            } else if (action.effect == "slide") {
                var actionClip = { command: action.command, direction: revertDirection(action.direction) };
                createDropAnimation(element, action, animation);
                createClipAnimation(element, actionClip, animation);
            } else if (action.effect == "slideCenter") {
                var actionClip = { command: action.command, direction: revertDirection(action.direction) };
                action.factor = 0.5;
                createDropAnimation(element, action, animation);
                createClipAnimation(element, actionClip, animation);
            } else if (action.effect == "drop") {
                createDropAnimation(element, action, animation);
                createFadeAnimation(element, action, animation);
            } else if (action.effect == "fold") {
                createClipAnimation(element, action, animation);
            } else if (action.effect == "scale" || action.effect == "puff") {
                if (action.effect == "scale") {
                    if (action.command == "show") {
                        action.scaleFrom = "0";
                        action.scaleTo = "1";
                    } else {
                        action.scaleFrom = "1";
                        action.scaleTo = "0";
                    }
                } else {
                    if (action.command == "show") {
                        action.scaleFrom = "1.5";
                        action.scaleTo = "1";
                    } else {
                        action.scaleFrom = "1";
                        action.scaleTo = "1.5";
                    }
                }
                createScaleAnimation(element, action, animation);
                createFadeAnimation(element, action, animation);
            } else {
                createFadeAnimation(element, action, animation);
            }
        } else if (action.command == "showPopup" || action.command == "hidePopup") {
            if (!element) {
                element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist
            }
            createPopup(element, action, animation);
        } else if (action.command == "jumpTo") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            jumpToHref(element, action, animation);

        } else if (action.command == "showLex") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            jumpToLex(element, action, animation);

        } else if (action.command == "evaluate") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            doEvaluate(element, action, animation);

        } else if (action.command == "resettest") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            resetTest(element, action, animation);
        } else if (action.command == "doZertPrint"){
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            printCert(element, action, animation);
        }else if (action.command == "mailPage"){
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            mailPage(element, action, animation);
        }else if (action.command == "savePage"){
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            savePage(element, action, animation);
        }else if (action.command == "showCalc"){
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            v3sCalculatorService.show(action.actor);
        } else if (action.command == "pauseTimeline" || action.command == "resumeTimeline" || action.command == "jumpToTimeline") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            controlTimeline(element, action, animation);
        } else if (action.command == "changeItem") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            changeItem(element, action, animation);
        } else if (action.command == "resetItem") {
            element = document; //Zwischenlösung, sonst kein Tween möglich, da element null ist (siehe oben)
            resetItem(element, action, animation);
        }



        animation.to.startAt = { // Tween-Initialisierung
            onComplete: function () { // Nach der Tween-Initialisierung vor dem Tween-Start
                if (!animation.to.css) { //sonst 2. fache Ausführung. Bug?
                    if (!!animation.onStartVisibility) animation.onStartVisibility();
                    if (!!animation.onStartDrop) animation.onStartDrop();
                    if (!!animation.onStartClip) animation.onStartClip();
                    if (!!animation.onStartScale) animation.onStartScale();
                    if (!!animation.onStartFade) animation.onStartFade();
                    TweenLite.set(element, animation.from);
                }
                notifyAnimationTweenCompleted(action);
            }
        };

        if (!animation.to.onComplete) {
            animation.to.onComplete = function () {
                unblockProperty(element.id, "visibility", animation.block);
                if (!!animation.end.visibility && !isPropertyBlocked(element.id, "visibility")) {
                    element.style.visibility = animation.end.visibility;
                }
                angular.forEach(animation.clearProps, function (prop) {
                    TweenLite.set(element, { clearProps: prop });
                });
            };
        }

        if (!animation.to.onReverseComplete) {
            animation.to.onReverseComplete = function () {
                if (!!animation.init.visibility) {
                    element.style.visibility = animation.init.visibility;
                }
            };
        }

        if (execute) {
            if (animation.to.onStart) {
                animation.to.onStart();
            }

        } else {
            if (!element) {
                element = document.createElement("div");
            }
            animation.to.delay = action.delay;
            tween = TweenMax.to(element, duration, animation.to);
            tween.data = animation.data;
        }

        return tween;
    }

    /**
     * Definiert Parameter für die Bewegungsanimation
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Zu animierendes Element
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createMoveAnimation(element, action, animation) {
        animation.to.left = action.x;
        animation.to.top = action.y;
    }

    /**
    * Definiert Parameter für die Bewegungsanimation entlang eines Pfades
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function createMoveAlongPathAnimation(element, action, animation) {
        var bezier = { values: [], type: action.bezier, autoRotate: action.autoRotate };

        if (action.bezier === "thru") {
            bezier.curviness = action.curviness;
        }

        if (action.path.indexOf("M") >= 0 || action.path.indexOf("m") >= 0) {
            bezier.values = MorphSVGPlugin.pathDataToBezier(action.path, { align: "relative" });

            if (!bezier.type) {
                bezier.type = "cubic";
            }

            animation.onStartMoveAlongPath = function () {
                var width = element.offsetWidth;
                var height = element.offsetHeight;

                TweenLite.set(element, { top: 0, left: 0 });
            };
        } else {
            var strPoints = action.path.split(" ");
            for (var i = 0; i < strPoints.length; i++) {
                var point = strPoints[i].split(",");
                bezier.values.push({ x: point[0], y: point[1] });
            }
        }

        animation.to.bezier = bezier;
    }

    /**
     * Definiert Parameter für die Skalierungssanimation
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Zu animierendes Element
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createScaleToAnimation(element, action, animation) {
        animation.to.scaleX = action.scaleX;
        animation.to.scaleY = action.scaleY;
    }

    /**
     * Definiert Parameter für die Rotierungssanimation
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Zu animierendes Element
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createRotateToAnimation(element, action, animation) {
        animation.to.rotation = action.rotation;
        animation.to.rotationX = action.rotationX;
        animation.to.rotationY = action.rotationY;
    }

    /**
         * Definiert Parameter für das Abspielen von Audio/Video
         * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
         * @param {Object} element - Zu animierendes Element
         * @param {Object} action - Aktion
         * @param {Object} animation.to - Ziel-Parameter
         */
    function createPlayback(element, action, animation) {

        var timeline = null,
            tween = null;

        animation.data = {

            /**
            * Initialisiert Audio/Video, aktualisiert die Timeline-Dauer
            * @param {Object} tween - Aktuelles Tween
            */
            onInit: function (_timeline, _tween) {

                timeline = _timeline;
                tween = _tween;

                if (!!timeline && !!timeline.data && timeline == tween.timeline) {

                    v3sMediaService.getMedia(action.object).then(function (media) {
                        media.showVideoControls(false);

                        media.getDuration().then(function (duration) {

                            tween.duration(duration);
                            timeline.data.updateProgressBar();

                            /*
                            media.onTimeUpdate(function (mediaTime) {
                                var delay = tween.time() - mediaTime;
                                if (!waiting && !timeline.paused() && delay > 0.5 && delay < 2) {
                                    waiting = true;
                                    timeline.pause();
                                } else if (waiting && timeline.paused()) {
                                    timeline.play();
                                }
                            });
                            */

                            media.onError(function () {
                                tween.data = null;
                                tween.kill();
                            });
                        });


                        /**
                        * Erweitert Tween, damit Audio/Video durch die Timeline gesteuert werden kann
                        */
                        tween.data = {
                            onPause: function () {
                                media.pause();
                            },
                            onPlay: function () {
                                if (tween.isActive()) {
                                    media.play(tween.time());
                                }
                            }
                        };

                    });
                }
            }
        };

        animation.to.onStart = function () {
            v3sMediaService.getMedia(action.object).then(function (media) {
                media.play(0);
            });
        };

        animation.to.onReverseComplete = function () {
            v3sMediaService.getMedia(action.object).then(function (media) {
                media.stop();
            });
        }
    }

    /**
        * Definiert Parameter für das Beenden (und Blockieren) der Wiedergabe von Audio/Video
        * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
        * @param {Object} element - Zu animierendes Element
        * @param {Object} action - Aktion
        * @param {Object} animation.to - Ziel-Parameter
        */
    function stopPlayback(element, action, animation) {
        var tween;
        animation.data = {

            /**
            * Initialisiert Audio/Video, aktualisiert die Timeline-Dauer
            * @param {Object} tween - Aktuelles Tween
            */
            onInit: function (_timeline, _tween) {
                tween = _tween;
                tween.data = {
                    onPlay: function () {
                        if (tween.isActive()) {
                            v3sMediaService.stopAll();
                        }
                    }
                };
            }
        };

        animation.to.onStart = function () {
            v3sMediaService.stopAll();
        };

    }

    /**
     * Definiert Parameter für das Anzeigen von Popups
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Wird nicht verwendet
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createPopup(element, action, animation) {
        animation.to.onStart = function () {
            if (action.command == "showPopup") {
                var actor = null;
                if (!!action.actor) {
                    actor = document.getElementById(action.actor);
                    if (!!actor) {
                        actor = angular.element(actor);
                    }
                }
                v3sPopupService.show(action.object, actor);
            } else {
                v3sPopupService.hide();
            }
        };

        animation.to.onReverseComplete = function () {
            if (action.command == "showPopup") {
                v3sPopupService.hide();
            }
        }
    }

    /**
     * Definiert Parameter für die Steuerung der Timeline
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Wird nicht verwendet
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function controlTimeline(element, action, animation) {
        var timeline = null;
        var async = true;
        animation.data = {
            onInit: function (_timeline, _tween, label) {
                timeline = _timeline;
                if (!!timeline.data) {
                    if (action.command == "pauseTimeline") {
                        if (!!label) {
                            timeline.data.addPause(label, action.delay, action.maxTime);
                            async = false;
                        }
                    }
                }
            }
        };

        animation.to.onStart = function () {
            if (!!timeline && !!timeline.data) {
                if (action.command == "pauseTimeline" && async) {
                    timeline.data.togglePause(true);
                } else if (action.command == "resumeTimeline") {
                    timeline.data.togglePause(false);
                } else if (action.command == "jumpToTimeline") {
                    timeline.data.jumpTo(action.time, true);
                }
            }
        };
    }

    /**
     * Definiert Parameter für das Ändern der Items in WBT
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Wird nicht verwendet
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function changeItem(element, action, animation) {

        var properties = action.property.split(";");

        var items = [];
        if (!!action.items) {
            var itemIds = action.items.split(";");
            angular.forEach(itemIds, function (itemId) {
                items = items.concat(v3sNavigationService.getItems(itemId));
            });
        }

        animation.to.onStart = function () {
            angular.forEach(items, function (item) {
                item.changeProperties(properties);
            });
        };
    }

    /**
     * Definiert Parameter für das Zurücksetzen der Items in WBT
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Wird nicht verwendet
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function resetItem(element, action, animation) {

        var items = [];
        if (!!action.items) {
            var itemIds = action.items.split(";");
            angular.forEach(itemIds, function (itemId) {
                var item = v3sNavigationService.getItem(itemId);
                if (!!item) {
                    items.push(item);
                }
            });
        }

        animation.to.onStart = function () {
            angular.forEach(items, function (item) {
                item.resetData();
            });
        };
    }

    /**
    * Definiert Parameter für die Ein-/Ausblenden-Animation
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function createVisibilityAnimation(element, action, animation) {
        animation.onStartVisibility = function () {
            animation.init.visibility = element.style.visibility || "inherit";

            if (action.command == "show") {
                animation.end.visibility = "inherit";
                animation.from.visibility = "inherit";
                animation.to.visibility = "inherit";

            } else if (action.command == "hide") {
                animation.end.visibility = "hidden";
            }

            animation.block = blockProperty(element.id, "visibility");
        }
    }


    /**
     * Definiert Parameter für die Ein-/Ausblenden-Animation
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Zu animierendes Element
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createFadeAnimation(element, action, animation) {

        animation.onStartFade = function () {
            var visibile = animation.init.visibility != "hidden";
            var opacity = element.style.opacity;

            if (action.command == "show") {
                animation.to.opacity = "1";

                if (!opacity && !visibile) {
                    animation.from.opacity = "0";
                }

            } else if (action.command == "hide") {
                animation.to.opacity = "0";
                if (!opacity && visibile) {
                    animation.from.opacity = "1";
                }
            }

            if (!animation.from.opacity && opacity == "") {
                animation.from.opacity = animation.to.opacity;
            }
        }

        animation.clearProps.push("opacity");
    }



    /**
         * Definiert Parameter für die Ein-/Ausblenden-Animation
         * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
         * @param {Object} element - Zu animierendes Element
         * @param {Object} action - Aktion
         * @param {Object} animation.to - Ziel-Parameter
         */
    function createScaleAnimation(element, action, animation) {

        animation.onStartScale = function () {
            var visibile = animation.init.visibility != "hidden";
            var transform = element.style.transform;

            if (action.command == "show" || action.command == "hide") {
                if (action.command == "show") {
                    animation.to.scale = action.scaleTo;
                    if (!transform && !visibile) {
                        animation.from.scale = action.scaleFrom;
                    }
                } else if (action.command == "hide") {
                    animation.to.scale = action.scaleTo;
                    if (!transform && !visibile) {
                        animation.from.scale = action.scaleFrom;
                    }
                }

                animation.clearProps.push("transform");

            } else {
                animation.to.scaleX = action.scaleX;
                animation.to.scaleY = action.scaleY;
            }
        };
    }

    /**
     * Definiert Parameter für die Clip-Animation (Ausschnitt)
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Zu animierendes Element
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createClipAnimation(element, action, animation) {

        animation.onStartClip = function () {
            var visibile = animation.init.visibility != "hidden";
            var clip = element.style.clip;

            var actualWidth = 0;
            var actualHeight = 0;
            var ngElementController = angular.element(element).controller("v3sText");
            if (!!ngElementController) {
                actualWidth = ngElementController.getActualWidth();
                actualHeight = ngElementController.getActualHeight();
            }

            var width = actualWidth > element.offsetWidth ? actualWidth : element.offsetWidth;
            var height = actualHeight > element.offsetHeight ? actualHeight : element.offsetHeight;
            var top = 0, right = 0, bottom = 0, left = 0;

            if ((action.command == "show" && action.direction.indexOf("left") > -1)
                || (action.command == "hide" && action.direction.indexOf("right") > -1)) {
                right = width;
                bottom = height;
                left = width;
            }

            if ((action.command == "show" && action.direction.indexOf("right") > -1)
                || (action.command == "hide" && action.direction.indexOf("left") > -1)) {
                bottom = height;
            }

            if ((action.command == "show" && action.direction.indexOf("top") > -1)
                || (action.command == "hide" && action.direction.indexOf("bottom") > -1)) {
                top = height;
                right = width;
                bottom = height;
            }

            if ((action.command == "show" && action.direction.indexOf("bottom") > -1)
                || (action.command == "hide" && action.direction.indexOf("top") > -1)) {
                right = width;
            }

            if (action.direction.indexOf("center") > -1) {
                top = bottom = height / 2;
                left = right = width / 2;
            }

            if (action.command == "show") {
                animation.to.clip = "rect(0px " + width + "px " + height + "px " + "0px)";

                if (!clip && !visibile) {
                    animation.from.clip = "rect(" + top + "px " + right + "px " + bottom + "px " + left + "px)";
                }

            } else if (action.command == "hide") {
                if (!clip && visibile) {
                    animation.from.clip = "rect(0px " + width + "px " + height + "px 0px)";
                }
                animation.to.clip = "rect(" + top + "px " + right + "px " + bottom + "px " + left + "px)";
            }

            if (!animation.from.clip && clip == "") {
                animation.from.clip = animation.to.clip;
            }

        };

        animation.clearProps.push("clip");
    }

    /**
     * Definiert Parameter für die Drop-Animation (Bewegung)
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} element - Zu animierendes Element
     * @param {Object} action - Aktion
     * @param {Object} animation.to - Ziel-Parameter
     */
    function createDropAnimation(element, action, animation) {
        animation.onStartDrop = function () {
            var visibile = animation.init.visibility != "hidden";
            var transform = element.style.transform;

            var fullSize = 100;

            if (!!action.factor) {
                fullSize = fullSize * action.factor;
            }

            if (action.command == "show") {
                animation.to.xPercent = "0%";
                animation.to.yPercent = "0%";

                if (!transform && !visibile) {
                    if (action.direction.indexOf("left") > -1) {
                        animation.from.xPercent = fullSize+"%";
                    } else if (action.direction.indexOf("right") > -1) {
                        animation.from.xPercent = "-"+fullSize+"%";
                    }
                    if (action.direction.indexOf("top") > -1) {
                        animation.from.yPercent = fullSize+"%";
                    } else if (action.direction.indexOf("bottom") > -1) {
                        animation.from.yPercent = "-" + fullSize + "%";
                    }
                }

            } else if (action.command == "hide") {
                if (action.direction.indexOf("left") > -1) {
                    animation.to.xPercent = "-" + fullSize + "%";
                } else if (action.direction.indexOf("right") > -1) {
                    animation.to.xPercent = fullSize + "%";
                }
                if (action.direction.indexOf("top") > -1) {
                    animation.to.yPercent = "-" + fullSize + "%";
                } else if (action.direction.indexOf("bottom") > -1) {
                    animation.to.yPercent = fullSize + "%";
                }

                if (!transform && visibile) {
                    animation.from.xPercent = "0%";
                    animation.from.yPercent = "0%";
                }
            }

            if (!animation.from.xPercent && !!animation.to.xPercent && transform == "") {
                animation.from.xPercent = animation.to.xPercent;
            }
            if (!animation.from.yPercent && !!animation.to.yPercent && transform == "") {
                animation.from.yPercent = animation.to.yPercent;
            }
        };

        animation.clearProps.push("transform");
    }

    /**
    * Definiert Parameter für das Navigieren zu externen URLs und Seiten.
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function jumpToHref(element, action, animation) {
        animation.to.onStart = function () {
            v3sLinkService.openLink(action.href);
        };
    }

    /**
    * Definiert Parameter für das Navigieren zu Lexikoneinträgen.
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function jumpToLex(element, action, animation) {
        animation.to.onStart = function () {
            v3sSearchService.hideLexikonEntry();
            v3sSearchService.init().then(function () {
                var path = v3sSearchService.findLexikonPath(action.entry);
                if (path) {
                    v3sSearchService.showLexikonEntry(path);
                }
            });
        };
    }

    /**
    * Definiert Parameter für das Auslösen der Auswertung von Aufgaben.
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function doEvaluate(element, action, animation) {

        var timeline = null;
        animation.data = {
            onInit: function (_timeline, _tween, label) {
                timeline = _timeline;
                if (!!timeline.data) {
                    timeline.data.allowUserInteraction(!action.evaluationType || action.evaluationType != "timeout");
                }
            }
        };

        animation.to.onStart = function () {
            if (!!action.evaluationType && action.evaluationType == "last") {
                v3sExerciseService.checkAllExercisesLast({ failedIfNoAnswer: true });
            } else if (!!action.evaluationType && action.evaluationType == "timeout") {
                v3sExerciseService.checkAllExercisesLast({ failedIfNoAnswer: true, timeout: true });
            }
            else {
                v3sExerciseService.checkAllExercises();
            }
        };
    }

    /**
    * Definiert Parameter für das Starten/Restarten eines Tests.
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function resetTest(element, action, animation) {
        animation.to.onStart = function () {
            var test;
            var testSco = v3sNavigationService.getItem("test");
            if (!!testSco) {
                test = testSco.getTest();
                test.start();
                v3sNavigationService.goTo(v3sNavigationService.getPageState(test.getFirstChild()));
            }
        };
    }

    /**
    * Definiert Parameter für das Drucken des Zertifikats
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function printCert(element, action, animation) {
        action.format = (!!action.format) ? action.format : "Standard";
        animation.to.onStart = function () {
            v3sPrintService.print(element, action.format);
        };
    }

    /**
    * Definiert Parameter für das E-Mailen des Zertifikates
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function mailPage(element, action, animation) {
        animation.to.onStart = function () {
            var link = "mailto:" + action.address
             + "?subject=" + encodeURIComponent(action.subject)
             + "&body=" + encodeURIComponent(action.text);

            var a = angular.element('<a class="not-visible"></a>');
            a.attr({
                'href': link
            });

            angular.element(element).find('v3s-document').append(a);
            $timeout(function () {
                a[0].click();
                a.remove();
            }, 1500);
        };
    }

    /**
    * Definiert Parameter für das Speichern einer Seite
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */
    function savePage(element, action, animation) {
        action.format = (!!action.format) ? action.format : "Standard";
        action.filename = (!!action.filename) ? action.filename : "screenshot";
        animation.to.onStart = function () {
            v3sPrintService.save(element, action.format, action.filename);
        };
    }

    /**
    * Definiert Parameter für das Öffnen des Taschenrechners
    *
    * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
    * @param {Object} element - Zu animierendes Element
    * @param {Object} action - Aktion
    * @param {Object} animation.to - Ziel-Parameter
    */

    function showCalc(element, action, animation) {
        v3sCalculatorService.showCalc();
    }

    /**
     * Kehrt die Animationsrichtung um
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {string} direction - Animationsrichtung
     * @return umgekehrte Animationsrichtung
     */
    function revertDirection(direction) {
        var result;

        result = direction.replace("left", "right");
        if (result == direction) {
            result = direction.replace("right", "left");
        }
        direction = result;

        result = direction.replace("top", "bottom");
        if (result == direction) {
            result = direction.replace("bottom", "top");
        }

        return result;
    }

    /**
     * Blockiert die Änderungen einer Eigenschaft
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {string} id - Element-ID
     * @param {string} property - CSS-Eigenschaft
     * @return Zahl zum Entblockeren
     */
    function blockProperty(id, property) {
        var timestamp = Date.now();

        if (!propertyBlocks[id + property]) {
            propertyBlocks[id + property] = {};
        }

        propertyBlocks[id + property][timestamp] = true;
        return timestamp;
    }

    /**
     * Hebt die Blockerung einer Eigenschaft auf
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {string} id - Element-ID
     * @param {string} property - CSS-Eigenschaft
     * @param {number} timestamp - Zahl zum Entblockieren
     */
    function unblockProperty(id, property, timestamp) {
        var blocks = propertyBlocks[id + property];
        if (!!blocks && !!timestamp && !!blocks[timestamp]) {
            delete blocks[timestamp];
        }
    }

    /**
     * Gibt zurück, ob die Änderungen einer Eigenschaft blockiert ist
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {string} id - Element-ID
     * @param {string} property - CSS-Eigenschaft
     */
    function isPropertyBlocked(id, property) {
        var blocks = propertyBlocks[id + property];
        return !!blocks && Object.keys(blocks).length > 0;
    }


    /**
     * Stoppt alle Animationen, die für die Elemente definiert sind
     * @memberOf v3sWbtPlayerApp:animation.service_v3sAnimationService
     * @param {Object} elements - Elemente mit Tweens
     */
    function killTweensOf(elements) {
        if (!!audio) {
            audio.stop();
        }
        propertyBlocks = {};
        TweenMax.killTweensOf(elements);
    }

    function subscribeAnimationTweenCompleted(callback) {
        var handler = $rootScope.$on('v3sAnimationTweenCompleted', callback);
    }

    function notifyAnimationTweenCompleted(action) {
        $rootScope.$emit('v3sAnimationTweenCompleted', action);
    }

    return {
        createTween: createTween,
        killTweensOf: killTweensOf,
        subscribeAnimationTweenCompleted: subscribeAnimationTweenCompleted,
        notifyAnimationTweenCompleted: notifyAnimationTweenCompleted
    }
}]);
